import { Injectable } from '@angular/core';
import * as fromConstants from '../../constants';
import { ApiEnvironmentService } from '../../services';
import { LocatorTools } from './locator-tools.enum';

@Injectable()
export class ToolIdentifierService {
  constructor(private apiService: ApiEnvironmentService) {}

  /***
   * Adding this for the tiem being so i can test with QS Params if needed to change the content
   */
  public getCurrentTool(): LocatorTools {
    const isDevMode = this.apiService.getIsDevMode();
    let locatorTool: LocatorTools = LocatorTools.HealthCenter;
    const url = window.location.href.toString().toLowerCase();
    const params = new URLSearchParams(new URL(url).search);
    const locationByParam = params.get('location');
    if (
      url.indexOf(fromConstants.UrlConstants.FindAHealthCenter) > -1 ||
      (locationByParam === fromConstants.UrlConstants.FindAHealthCenter && isDevMode)
    ) {
      locatorTool = LocatorTools.HealthCenter;
    } else if (
      url.indexOf(fromConstants.UrlConstants.OPTOXFind) > -1 ||
      (locationByParam === fromConstants.UrlConstants.OPTOXFind && isDevMode)
    ) {
      locatorTool = LocatorTools.OrganTransplantCenter;
    } else if (
      url.indexOf(fromConstants.UrlConstants.FindHIVCare) > -1 ||
      (locationByParam === fromConstants.UrlConstants.FindHIVCare && isDevMode)
    ) {
      locatorTool = LocatorTools.HIVMedicalProvider;
    } else if (
      url.indexOf(fromConstants.UrlConstants.FindANetwork) > -1 ||
      (locationByParam === fromConstants.UrlConstants.FindANetwork && isDevMode)
    ) {
      locatorTool = LocatorTools.HealthCenterControlledNetwork;
    } else if (
      url.indexOf(fromConstants.UrlConstants.HDSLocator) > -1 ||
      (locationByParam === fromConstants.UrlConstants.HDSLocator && isDevMode)
    ) {
      locatorTool = LocatorTools.MigrantSeasonalHeadStart;
    }

    return locatorTool;
  }
}
